import fetchRestData from '../../helpers/fetchResData'
import { FEED_PAGE_SIZE } from '../../helpers/const'

/**
 * Given a flyerId, fetch a single page of flyer's gibs.
 * Returns the raw { data, metadata } response, total count is in metadata.count
 * @param {Object} params
 * @param {string} params.flyerId
 * @param {number} [params.page]
 * @param {number} [params.limit]
 * @param {string} [params.q] - server-side search query
 */

export const fetchFlyerGibsPage = ({
  flyerId, page = 1, limit = FEED_PAGE_SIZE, q,
}) => {
  const options = {
    resource: `flyers/${flyerId}/flyer_gibs`,
    paginate: false,
    dataOnly: false,
    params: {
      limit,
      page,
      ...(q ? { q } : {}),
    },
  }

  return fetchRestData(options)
}
